import BugsnagPluginReact from '@bugsnag/plugin-react'
import Bugsnag, { developmentLogger } from 'utils/bugsnag'
import packageJson from '../../../package.json'

const { version } = packageJson

export function initErrorHandling() {
  Bugsnag.start({
    releaseStage: import.meta.env.MODE, // 'development' or 'production'
    apiKey: __BUGSNAG_KEY__,
    plugins: [new BugsnagPluginReact()],
    appVersion: __APP_VERSION__,
    enabledReleaseStages: ['production'],
    redactedKeys: [
      'Authorization', // remove tokens from headers (Authorization: "Bearer <token>")
      /^X-Auth-Token$/i, // remove cookie token
      /^xsrf/,
      /^password$/i, // remove any times we try to report a password
    ],
    logger: import.meta.env.PROD ? null : developmentLogger,
  })
}
